import { render, staticRenderFns } from "./LoginWithToken.vue?vue&type=template&id=1546330b&scoped=true&"
import script from "./LoginWithToken.vue?vue&type=script&lang=js&"
export * from "./LoginWithToken.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1546330b",
  null
  
)

export default component.exports